import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pre-with-ellipsis" }
const _hoisted_2 = { class: "placeholder" }

import {} from 'vue'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'PreWithEllipsis',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("pre", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})